import { render, staticRenderFns } from "./ReportLinkForm.vue?vue&type=template&id=2f70e62c&"
import script from "./ReportLinkForm.vue?vue&type=script&lang=js&"
export * from "./ReportLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports